import { render, staticRenderFns } from "./SlideSubmitButtonWrapper.vue?vue&type=template&id=72900bde&scoped=true&"
import script from "./SlideSubmitButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./SlideSubmitButtonWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SlideSubmitButtonWrapper.vue?vue&type=style&index=0&id=72900bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72900bde",
  null
  
)

export default component.exports